import React from "react";
import EllipsisTooltip from "./EllipsisTooltip";

const TruckListRowData = ({ orderData }) => {
  return (
    <>
      {orderData?.length > 0 ? (
        <div>
          {orderData?.map((item) => (
            <div className="row row-data" key={item.id}>
              <div className="filter-item-search filter-item-search--small text-truncate">
                <EllipsisTooltip text={item?.a_number}>
                  {item?.a_number}
                </EllipsisTooltip>
              </div>
              <div className="filter-item-search  filter-item-search--small text-truncate">
                <EllipsisTooltip text={item?.chassis_no}>
                  {item?.chassis_no}
                </EllipsisTooltip>
              </div>
              <div className="filter-item-search  filter-item-search--small text-truncate">
                <EllipsisTooltip text={item?.license_plate}>
                  {item?.license_plate}
                </EllipsisTooltip>
              </div>
              <div className="filter-item-search  filter-item-search--large">
                <EllipsisTooltip text={item?.customer}>
                  {item?.customer}
                </EllipsisTooltip>
              </div>
              <div className="filter-item-search text-truncate">
                <EllipsisTooltip text={item?.receipt_date_planned}>
                  {item?.receipt_date_planned ? item?.receipt_date_planned : ""}
                </EllipsisTooltip>
              </div>
              <div className="filter-item-search text-truncate">
                <EllipsisTooltip text={item?.planned_delivery_date}>
                  {item?.planned_delivery_date ? item?.planned_delivery_date : ""}
                </EllipsisTooltip>
              </div>
              <div className="filter-item-search text-truncate">
                <EllipsisTooltip text={item?.model}>
                  {item?.model}
                </EllipsisTooltip>
              </div>
              <div className="filter-item-search filter-item-search--xtrasmall text-truncate">
                <EllipsisTooltip text={item?.vestigingen}>
                  {item?.vestigingen}
                </EllipsisTooltip>
              </div>
            </div>
          ))}
        </div>
      ): <p className="text-center mt-5">No items found</p> }
    </>
  );
};

export default TruckListRowData;
